<template>
  <v-container v-if="!$vuetify.breakpoint.mobile">
    <v-row no-gutters justify="space-around">
      <BanerTile
        v-for="(slot,index) in slots" :key="index"
        :banner="getRandomBanerFromSlot(index)"/>
    </v-row>
  </v-container>
</template>

<script>
import BanerTile from '@/components/Partials/ShopBody/BanerTile.vue';
import { state } from '../../../store/index';

export default {
  name: 'BanersRow',
  components: { BanerTile },
  computed: {
    slots() {
      const tempBanerSlots = {
        1: [],
        2: [],
        3: [],
        4: [],
      };

      Object.keys(tempBanerSlots).forEach((slotNumber) => {
        if (state.baners.length > 0) {
          const bannerKeys = `position${slotNumber}`;
          if (typeof state.baners[0] === 'object'
            && typeof state.baners[0][bannerKeys] === 'object') {
            tempBanerSlots[slotNumber] = Object.values(state.baners[0][bannerKeys]);
          }
        }
      });

      return tempBanerSlots;
    },
  },
  methods: {
    getRandomBanerFromSlot(slotNumber) {
      const banners = this.slots[slotNumber];
      const randomNo = Math.floor(Math.random() * banners.length);
      return banners[randomNo];
    },
  },
};
</script>

<style scoped>

</style>
